import { FolderSync } from "lucide-react";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import { useRestoreSourcesFromYaml } from "@/hooks/useSources";

/**
 * Restores DB-owned source config from the YAML backup/seed files.
 */
export function RestoreYamlButton() {
  const restore = useRestoreSourcesFromYaml();

  const onClick = async () => {
    const confirmed = window.confirm(
      "Restore source config from YAML backup? This overwrites DB-owned source config.",
    );
    if (!confirmed) {
      return;
    }
    try {
      const report = await restore.mutateAsync();
      const summary = [
        report.added.length ? `+${report.added.length}` : null,
        report.updated.length ? `~${report.updated.length}` : null,
        report.reactivated.length ? `re${report.reactivated.length}` : null,
        report.deactivated.length ? `-${report.deactivated.length}` : null,
      ]
        .filter(Boolean)
        .join(" ");
      toast.success(summary ? `Restore complete (${summary})` : "Restore complete");
    } catch (err) {
      toast.error(`Restore failed: ${(err as Error).message}`);
    }
  };

  return (
    <Button variant="outline" size="sm" onClick={onClick} disabled={restore.isPending}>
      <FolderSync className={restore.isPending ? "animate-spin" : undefined} />
      {restore.isPending ? "Restoring…" : "Restore YAML"}
    </Button>
  );
}
